export default __webpack_public_path__ + "static/media/Rank_top_nav_bar_bg1.da94cc13.svg";